export class Button {
  text:string;
  value:string;

  constructor(text:string, value:string) {
    this.text = text;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/button.ts